import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import '../css/autocomplete.scss';

import SuggestionsDropdown from './autocomplete/SuggestionsDropdown';

function Autocomplete( props ) {
    const [ searchQuery, setSearchTerm ] = useState( props.searchQuery )

    return (
        <div className="search-autocomplete">
            <div className="search-field">
                <input 
                    type="search" 
                    className="search-field__input"
                    name={ props.name }
                    placeholder="Search"
                    aria-label="Term to search"
                    value={ searchQuery }
                    onChange={ ( e ) => setSearchTerm( e.target.value ) }
                    list="wpes-datalist"
                    autoComplete="off"
                />

                <button className="search-field__submit" role="submit">
                    <span className="sr-only">Search the website</span>
                </button>

                <SuggestionsDropdown searchQuery={ searchQuery } />
            </div>
        </div>
    )
}

let autocomplete = document.getElementById('wpes-autocomplete')

if ( null !== autocomplete ) {
    let name  = autocomplete.getAttribute('data-name'),
        query = autocomplete.getAttribute('data-query')

    if ( null !== name && null !== query ) {
        ReactDOM.render(
            <Autocomplete 
                name={ name } 
                searchQuery={ query }
            />,
            autocomplete
        )
    }
}